import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import { cn } from "@omni/utils/styles";
import React from "react";

export type FormTextComponentProps = {
    inline?: boolean;
    color?: string;
};

export type FormTextProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, FormTextComponentProps, "small">;

const FormText = <T extends React.ElementType = "small">({
    className,
    inline,
    color,
    tag,
    ...attributes
}: FormTextProps<T>) => {
    const Tag = tag || ("small" as React.ElementType);
    const classes = cn(
        className,
        !inline ? "form-text" : false,
        color ? `text-${color}` : false
    );

    return (
        <Tag
            {...attributes}
            className={classes}
        />
    );
};

export { FormText };
